import { Bars3Icon } from "@heroicons/react/24/outline";
import { Logo } from "./Logo.tsx";
import { SignedInUserMenu } from "./SignedInUser.tsx";

export function NavBar({ onOpenMobileMenu }: { onOpenMobileMenu: () => void }) {
  return (
    <div
      className={
        "p-4 shadow-xl shadow-slate-200/10 w-full flex items-center justify-between md:justify-end gap-4 bg-white"
      }
    >
      <div className={"md:hidden"}>
        <Logo />
      </div>
      <div className={"flex items-center gap-3 min-w-0"}>
        <div className={"hidden md:block"}>
          <SignedInUserMenu />
        </div>
        <button
          type={"button"}
          onClick={onOpenMobileMenu}
          aria-label={"Open menu"}
          className={"md:hidden p-2 -mr-2 rounded-lg hover:bg-slate-100"}
        >
          <Bars3Icon className={"h-6 w-6"} />
        </button>
      </div>
    </div>
  );
}
